import React, { useState, useEffect } from "react";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import styles from "./styles.js";
import withStyles from "@material-ui/core/styles/withStyles";

const EasyRegionDropdown = (props) => {
  const { classes, connectForm } = props;
  const propName = props.propName;
  const [loading, setLoading] = useState(true);
  const [regionCodebook, setRegionCodebook] = useState([]);

  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  if (loading) {
    connectForm.getCodebookDropdownOptions("region").then((r) => {
      setRegionCodebook(r);
    });
    setLoading(false);
  }

  let returnType = "id";
  if (props.returnType != null) {
    if (props.returnType === "id") {
      returnType = "id";
    } else if (props.returnType === "provinceshort") {
      returnType = "provinceshort";
    } else {
      throw new Error("Unknow region returntype");
    }
  }

  return (
    <FormControl
      fullWidth
      className={classes.selectFormControl}
      error={props.connectForm.getState(propName) === "Error"}
    >
      <InputLabel htmlFor={propName} className={classes.selectLabel}>
        Province
        {props.connectForm.isRequired(propName) ? "*" : ""}
      </InputLabel>
      <Select
        error={props.connectForm.getState(propName) === "Error"}
        MenuProps={{
          className: classes.selectMenu,
        }}
        classes={{
          select: classes.select,
        }}
        value={props.connectForm.getValue(propName)}
        onChange={(event) =>
          props.connectForm.change(event.target.value, propName)
        }
        inputProps={{
          name: propName,
          id: propName,
        }}
      >
        <MenuItem
          disabled
          classes={{
            root: classes.selectMenuItem,
          }}
        >
          Canada
        </MenuItem>
        {regionCodebook.map((element, key) => {
          if (element.countryid === 1) {
            return (
              <MenuItem
                key={key}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelect,
                }}
                value={element[returnType]}
              >
                {`${element.provincelong} (${element.provinceshort})`}
              </MenuItem>
            );
          }
          return null;
        })}
        <MenuItem
          disabled
          classes={{
            root: classes.selectMenuItem,
          }}
        >
          United States
        </MenuItem>
        {regionCodebook.map((element, key) => {
          if (element.countryid === 2) {
            return (
              <MenuItem
                key={key}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelect,
                }}
                value={element[returnType]}
              >
                {`${element.provincelong} (${element.provinceshort})`}
              </MenuItem>
            );
          }
          return null;
        })}
      </Select>
    </FormControl>
  );
};

export default withStyles(styles)(EasyRegionDropdown);
